import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  dearTypeFindAll (params) {
    return axios.post(global.CMC_BASE + '/dearType/findAllDearType', params)
  },
  dearTypeDelete (params) {
    return axios.post(global.CMC_BASE + '/dearType/deleteDearType', params)
  },
  dearTypeInsert (params) {
    return axios.post(global.CMC_BASE + '/dearType/insertDearType', params)
  },
  dearTypeUpdate (params) {
    return axios.post(global.CMC_BASE + '/dearType/updateDearType', params)
  },
  findDearByRegionId (params) {
    return axios.post(global.CMC_BASE + '/dear/findDearByRegionId', params)
  },
  findAllDear (param) {
    return axios.post(global.CMC_BASE + '/dear/findAllDear', param)
  }
}



// WEBPACK FOOTER //
// ./src/request/cmc/dear.js